import { empApi } from "./client";

// Danh sách khách hàng -> { items, pagination }
export const getCustomerListApi = (params) => empApi.get("/customer/app", params);

// Thống kê -> { total, totalPersonal, totalBusiness }
export const getCustomerStatisticApi = () => empApi.get("/customer/app/statistic");

// Chi tiết khách hàng
export const getCustomerByIdApi = (id) => empApi.get(`/customer/app/${id}`);

// Loại khách hàng (để lọc) -> { items }
export const getCustomerTypeListApi = (params = { page: 1, limit: 999 }) =>
  empApi.get("/customerType", params);

// Nghề nghiệp -> { items }
export const getJobListApi = (params = { page: 1, limit: 999 }) =>
  empApi.get("/job", params);

// Xóa khách hàng
export const deleteCustomerApi = (id) => empApi.del(`/customer/app/${id}`);

// Tạo khách hàng cá nhân
export const createCustomerPersonalApi = (body) => empApi.post("/customer/app", body);

// Tạo khách hàng doanh nghiệp
export const createCustomerBusinessApi = (body) => empApi.post("/customer/app/business", body);

// Yêu cầu cập nhật khách hàng (dùng cho cả cá nhân & doanh nghiệp khi sửa)
export const createCustomerUpdateRequestApi = (body) =>
  empApi.post("/customerUpdateRequest/app", body);
